import {useEffect, useState} from "react";
import {useSelector} from "react-redux";
import {quoteCart} from "../api/shop";

export const useCartAmounts = () => {
  const user = useSelector(state => state.aplicationConfig.userConfig);
  const key = JSON.stringify({
    lines: (user.cart?.ShoppingCartProducts || []).map(({productId, quantity, variantId, itemIds, note}) => ({productId, quantity, variantId, itemIds, note})),
    shoppingCartId: user.cart?.shoppingCartId,
    discountIds: (user.cart?.Discounts || []).map(discount => discount.discountId).sort(),
    shippingMethodId: user.checkout?.deliveryMethod?.shippingMethodId,
  });
  const [attempt, setAttempt] = useState(0);
  const [quote, setQuote] = useState({key:null, amounts:null, busy:true, error:false});
  useEffect(() => {
    let active = true;
    setQuote({key, amounts:null, busy:true, error:false});
    (async () => {
      try {
        const response = await quoteCart(JSON.parse(key));
        const amounts = response?.data;
        if (response?.error !== false || !["subtotal", "discounts", "base", "tax", "shipping", "total"].every(field => typeof amounts?.[field] === "number" && Number.isFinite(amounts[field]))) throw new Error("Amount unavailable");
        if (active) setQuote({key, amounts, busy:false, error:false});
      } catch {
        if (active) setQuote({key, amounts:null, busy:false, error:true});
      }
    })();
    return () => {active = false;};
  }, [key, attempt]);
  const current = quote.key === key ? quote : {amounts:null, busy:true, error:false};
  return {...current, amounts: user.cartDiscountBusy ? null : current.amounts, busy: current.busy || Boolean(user.cartDiscountBusy), retry:() => {if (!current.busy) setAttempt(value => value + 1);}};
};
